import React, {Fragment, useEffect, useState} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import {getReorderedItems} from "../../lookNavigation/lookNavigationFunctions";
import {getCurrentLayout} from "../../../appLayout";
import ShopCategoryVirtualizedGrid from "./shopCategoryVirtualizedGrid";
import {shopContextAction, useShopContext} from "./shopNavItemsContext";
import {scrolledVerticalToTheEnd} from "../../../visComponents/navigation/navUtils";
import {getAdditionalFeaturesOnScroll} from "../../../../api/look-api";
import NavigationLoader from "../../ui/navigationLoader";
import ShopCategoryAside from "./shopCategoryAside";
import ShopCategoryBackNextButtons from "./shopCategoryBackNextButtons";
import MaterialSpinner from "../../../ui/materialSpinner";

const useSimpleView = window.location.href.includes("quoteremodel");


const ShopCategoryList = (props) => {

  const {featureGroup, filterGroups, selectedFilters, scrollElement, navigationCount, isMobile, windowWidth,
    allFeaturesWereLoaded} = props;

  const [additionalFeaturesLoading, setAdditionalFeaturesLoading] = useState(false);
  const {shopContextState, shopContextDispatch} = useShopContext();
  const {shopNavItems, shopAllNavItems, shopNavItemsLoaded} = shopContextState;

  const startLoadingAdditionalFeatures = async (scrolling = true) => {
    setAdditionalFeaturesLoading(true);
    if (scrolling) {
      await new Promise(resolve => setTimeout(resolve, 300));
    }
    await getAdditionalFeaturesOnScroll(featureGroup);
    await setReceivedFeatures();
    if (scrolling) {
      await new Promise(resolve => setTimeout(resolve, 300));
    }
    setAdditionalFeaturesLoading(false);
  }

  const setReceivedFeatures = () => {
    const layout = getCurrentLayout();
    let navFeatures = layout.designNavigationItems(
      {part: featureGroup},
      selectedFilters,
      "",
      featureGroup.activeFeature,
      true,
      filterGroups,
      {returnAllFeatures: true} // here we request all features
    );
    navFeatures = getReorderedItems(navFeatures,null, featureGroup.id, featureGroup);

    const shopAllNavItems = layout.designNavigationItems(
      {part: featureGroup},
      [],
      "",
      featureGroup.activeFeature,
      true,
      filterGroups,
      {returnAllFeatures: true} // here we request all features
    );

    shopContextDispatch(shopContextAction({shopNavItems: navFeatures, shopAllNavItems}));
    if (!shopNavItemsLoaded && featureGroup.allFeaturesReceived) {
      shopContextDispatch(shopContextAction({shopNavItemsLoaded: true}));
    }
    if (!featureGroup.getRealFeaturesReceivedProperty()) {
      setTimeout(() => {
        if (featureGroup.allFeaturesReceived && !featureGroup.getRealFeaturesReceivedProperty() && scrollElement && scrollElement.current
          && (scrollElement.current.clientHeight >= scrollElement.current.scrollHeight)
          && featureGroup.getNextPageToLoad() < 2) { // no need to make many requests, we should check why features are missing
          startLoadingAdditionalFeatures(false);
        }
      }, 500)
    }
  }

  useEffect(() => {
    setReceivedFeatures();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureGroup, selectedFilters, navigationCount])

  if (!scrollElement || !scrollElement.current) {
    return null
  }

  const onScrollHandler = async (scrollObject) => {
    if (!featureGroup) {
      return;
    }
    if (featureGroup.getRealFeaturesReceivedProperty() || !scrolledVerticalToTheEnd(scrollObject)) {
      return
    }
    startLoadingAdditionalFeatures();
  }

  if (!shopNavItemsLoaded) {
    return <MaterialSpinner/>
  }

  if (!shopNavItems.length && shopNavItemsLoaded && !selectedFilters.length) {
    return <h3 className="shop-content shop-content--centered">No features available</h3>
  }

  return (
    <Fragment>
      <ShopCategoryAside featureGroup={featureGroup} shopNavItems={shopAllNavItems}/>
      <ShopCategoryBackNextButtons/>
      <div className="shop-content">
        <ShopCategoryVirtualizedGrid renderList={shopNavItems}
                                     useSimpleView={useSimpleView}
                                     scrollElement={scrollElement.current}
                                     windowWidth={windowWidth}
                                     onScrollHandler={
                                       allFeaturesWereLoaded.includes(document.kvConfig.visualizerType) ? null : onScrollHandler
                                     }
                                     isMobile={isMobile}/>
        {additionalFeaturesLoading ? <NavigationLoader className={" shop-overlay"}/> : null}
      </div>
    </Fragment>
  )
};

ShopCategoryList.propTypes = {
  scrollElement: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
    PropTypes.shape({current: PropTypes.instanceOf(Element)})
  ]),
}

const mapStateToProps = (store) => {
  const {navigationCount} = store.lookState;
  const {selectedFilters, filterGroups} = store.filterState;
  const {isMobile, windowWidth, allFeaturesWereLoaded} = store.serverState;

  return {
    navigationCount,
    filterGroups,
    selectedFilters,
    isMobile,
    windowWidth,
    allFeaturesWereLoaded,
  };
};

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShopCategoryList)
)
